<script>
  import { _ } from "../../services/i18n";
</script>

<section class="section-composition">
  <table class="table-composition">
    <tr>
      <td class="box-composition" id="e-box">
        <a href="#/tuto?/compositor/composition">
          <h5>{$_("tutorial_nav_elements")}</h5>
          <div class="info-composition">
            <p>Saber más</p>
            <img id="user-composition" src="/icons/arrow-left-white.svg" alt="close" />
          </div>
          <img id="element-composition" src="/icons/silla.png" alt="close" />
        </a>
      </td>
      <td class="box-composition" id="m-box">
        <a href="#/tuto?/compositor/materials">
          <h5>{$_("tutorial_nav_materials")}</h5>
          <div class="info-composition">
            <p>Saber más</p>
            <img id="user-composition" src="/icons/arrow-left-white.svg" alt="close" />
          </div>
          <img id="element-composition" src="/icons/metraje.png" alt="close" />
        </a>
      </td>
    </tr>

    <tr>
      <td class="box-composition" id="a-box">
        <a href="#/tuto?/compositor/accessories">
          <h5>{$_("tutorial_nav_accessories")}</h5>
          <div class="info-composition">
            <p>Saber más</p>
            <img id="user-composition" src="/icons/arrow-left-white.svg" alt="close" />
          </div>
          <img id="element-composition" src="/icons/pata.png" alt="close" />
        </a>
      </td>

      <td class="box-composition" id="s-box">
        <a href="#/tuto?/compositor/summary">
          <h5>{$_("tutorial_nav_summary")}</h5>
          <div class="info-composition">
            <p>Saber más</p>
            <img id="user-composition" src="/icons/arrow-left-white.svg" alt="close" />
          </div>
          <img id="element-composition" src="/icons/carrito.png" alt="close" />
        </a>
      </td>
    </tr>
  </table>
</section>


